import React from 'react'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

export const DepreciationDetail = (props: any) => {
  const { CompanyID, listEl } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc">Asset Name</div>
        <div className="xxTitle">{listEl?.name || '-'}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Category</div>
        <div className="xxTitle">{listEl?.Category?.name || '-'}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc">Depreciation Method</div>
        <div className="xxTitle">{listEl?.DepreciationMethod?.name || '-'}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Registration Date</div>
        <div className="xxTitle">
          {formatDate(listEl?.registration_date) || '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc">Start Use Date</div>
        <div className="xxTitle">
          {formatDate(listEl?.start_use_date) || '-'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Original Amount</div>
        <div className="xxTitle">
          {listEl?.base_original_amount !== null &&
          listEl?.base_original_amount !== undefined
            ? amtStr(listEl?.base_original_amount)
            : '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc">Opening Acc. Depreciation</div>
        <div className="xxTitle">
          {listEl?.opening_accumulated_depreciation !== null &&
          listEl?.opening_accumulated_depreciation !== undefined
            ? amtStr(listEl?.opening_accumulated_depreciation)
            : '-'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Original Net Amount</div>
        <div className="xxTitle">
          {listEl?.original_net_amount !== null &&
          listEl?.original_net_amount !== undefined
            ? amtStr(listEl?.original_net_amount)
            : '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc">Residual Value</div>
        <div className="xxTitle">
          {listEl?.residual_value !== null &&
          listEl?.residual_value !== undefined
            ? amtStr(listEl?.residual_value)
            : '-'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Useful Life</div>
        <div className="xxTitle">
          {listEl?.opening_depreciation_useful_life !== null &&
          listEl?.opening_depreciation_useful_life !== undefined
            ? `${listEl?.opening_depreciation_useful_life} months`
            : '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc">Utilized Useful Life</div>
        <div className="xxTitle">
          {listEl?.depreciation_utilized_useful_life !== null &&
          listEl?.depreciation_utilized_useful_life !== undefined
            ? `${listEl?.depreciation_utilized_useful_life} months`
            : '0 months'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc">Start Period</div>
        <div className="xxTitle">
          {listEl?.depreciation_start_period && listEl?.depreciation_start_year
            ? `${listEl?.depreciation_start_period}/${listEl?.depreciation_start_year}`
            : '-'}
        </div>
      </div>

      <div className="content-wrap full">
        <div className="desc">Remark</div>
        <div className="xxTitle">{listEl?.remark || '-'}</div>
      </div>
    </>
  )
}
